module.exports = __webpack_public_path__ + "img/2019.10.00bf92ed.png";